export class FilterEntity {
    name: string = '';
    value: string = '';
}

